import { formatUrl } from "@config/utils";

export default {
    computed: {
        applicationCode() {
            return this.$store.getters.applicationCode;
        },
    },
    methods: {
        prepareUrl(url) {
            return url ? formatUrl(url, {applicationCode: this.applicationCode}) : null;
        },
    }
};
